export const title: string = `Who will drive your car?`;
export const policyHolder: string = `Policy holder`;
export const aD: string = `Additional driver`;
export const remove: string = `Remove`;
export const edit: string = `Edit`;
export const addDriver: string = `Add a driver`;
export const close: string = `Close`;
export const cancel: string = `Cancel`;
export const yesRemove: string = `Yes, remove`;
export const areYouSure: string = `Are you sure you want to remove this driver?`;
